import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import VisibilitySensor from 'react-visibility-sensor';
import 'animate.css';
import './ProductShowcaseDemo.css';

// Sample product data - Replace with your actual data
const products = [
  {
    id: 1,
    name: 'ClinTa Web-Builder',
    description: 'A platform designed to help doctors, clinics, and hospitals build and manage professional websites without technical skills.',
    image: '/assets/img/homepage-wb.svg',
    link: '/web-builder',
  },
  {
    id: 2,
    name: 'ClinTa LARIS',
    description: 'Complete laboratory management with automated workflows, machine integration, and secure reporting.',
    image: '/assets/img/homepage-laris.svg',
    link: '/laris',
  },
  {
    id: 3,
    name: 'ClinTa MAPS',
    description: 'Complete pharmacy management with inventory control, automated billing, and prescription tracking.',
    image: '/assets/img/homepage-maps.svg',
    link: '/maps',
  },
  {
    id: 4,
    name: 'Web Builder Platform',
    description: 'Build professional websites for doctors, hospitals, and labs without coding.',
    image: '/assets/img/doc_webbuilder.png',
    link: '/web-builder',
  },
  {
    id: 5,
    name: 'Clinic Management',
    description: 'Streamlined clinic operations with appointment scheduling and patient records.',
    image: '/assets/img/banner1.png',
    link: '/quest',
  },
  {
    id: 6,
    name: 'Telemedicine Platform',
    description: 'Connect patients with doctors through secure video consultations.',
    image: '/assets/img/banner2.png',
    link: '/quest',
  }
];

// Product Card Component
const ProductCard = ({ product, index, isVisible, animationClass = '' }) => (
  <div 
    className={`product-card ${isVisible ? `animate__animated ${animationClass}` : ''}`}
    style={{ animationDelay: `${index * 0.1}s` }}
  >
    <div className="product-card-inner">
      <div className="product-image-wrapper">
        <img src={product.image} alt={product.name} className="product-image" />
      </div>
      <div className="product-card-body">
        <h5 className="product-title">{product.name}</h5>
        <p className="product-description">{product.description}</p>
        <div className="product-footer">
          <Link to={product.link || '/quest'} className="btn btn-brand-02 btn-sm">View Details</Link>
        </div>
      </div>
    </div>
  </div>
);

// View More Card - Icon Circle Style
const ViewMoreCard = ({ isVisible }) => (
  <Link 
    to="/quest" 
    className={`view-more-card style-4 ${isVisible ? 'animate__animated animate__fadeInUp' : ''}`}
    style={{ animationDelay: '0.2s' }}
  >
    <div className="view-more-card-inner style-4-inner">
      <div className="view-more-icon-circle">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4V20M4 12H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>
      <h5>View Other Products</h5>
      <p>Explore our complete range of healthcare software solutions</p>
      <div className="view-more-arrow-circle">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  </Link>
);

// Featured + Grid Showcase
function ProductShowcase() {
  const [isVisible, setIsVisible] = useState(false);
  const featured = products[0];
  const others = products.slice(1, 3); // Show only 2 cards

  const handleVisibilityChange = (visible) => {
    if (visible && !isVisible) {
      setIsVisible(true);
    }
  };

  return (
    <section id="product-showcase" className="product-showcase ptb-100 integrated-healthcare-section">
      <div className="container">
        {/* Section Heading */}
        <div className="section-heading text-center mb-5">
          <h2 className="web">Integrated Healthcare Solutions</h2>
          <p>Thoughtfully designed systems that deliver reliable performance, scale with growing needs, and support real-world healthcare operations.</p>
        </div>

        <VisibilitySensor onChange={handleVisibilityChange} partialVisibility>
          <div>
            {/* Featured Product */}
            <div className="row mb-4">
              <div className="col-12">
                <div className={`featured-product ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <img src={featured.image} alt={featured.name} className="featured-image" />
                    </div>
                    <div className="col-md-6">
                      <div className="featured-content">
                        <span className="featured-badge">Featured Product</span>
                        <h3>{featured.name}</h3>
                        <p>{featured.description}</p>
                        <Link to="/web-builder" className="btn btn-brand-02 mt-3">View Details</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Product Grid with View More */}
            <div className="row">
              {others.map((product, index) => (
                <div key={product.id} className="col-md-6 col-lg-4 mb-4">
                  <ProductCard 
                    product={product} 
                    index={index} 
                    isVisible={isVisible}
                    animationClass="animate__fadeInUp"
                  />
                </div>
              ))}
              {/* View More Card - Icon Circle Style */}
              <div className="col-md-6 col-lg-4 mb-4">
                <ViewMoreCard isVisible={isVisible} />
              </div>
            </div>
          </div>
        </VisibilitySensor>
      </div>
    </section>
  );
}

export default ProductShowcase;
